import { useEffect } from "react";

/**
 * Anchor the platform "Made with Emergent" badge at the very bottom of the
 * page and recolour it to match the site palette. Uses JS because the badge
 * is injected with inline styles + !important, which beats stylesheet rules.
 */
export const useEmergentBadgeStyle = () => {
  useEffect(() => {
    const apply = (el) => {
      if (!el) return;
      const overrides = {
        position: "static",
        display: "block",
        width: "100%",
        height: "auto",
        margin: "0",
        padding: "10px 16px",
        gap: "8px",
        "border-radius": "0",
        background: "#C2DDED",
        color: "rgba(31, 92, 138, 0.55)",
        "box-shadow": "none",
        "text-align": "center",
        "border-top": "1px solid rgba(31, 92, 138, 0.12)",
        "font-size": "11px",
        "letter-spacing": "0.08em",
        "z-index": "0",
        bottom: "auto",
        right: "auto",
        top: "auto",
        left: "auto",
      };
      Object.entries(overrides).forEach(([k, v]) => {
        el.style.setProperty(k, v, "important");
      });

      // Re-colour inner text + icons
      el.querySelectorAll("p, span").forEach((c) => {
        c.style.setProperty("color", "inherit", "important");
        c.style.setProperty("font-size", "11px", "important");
        c.style.setProperty("letter-spacing", "0.08em", "important");
        c.style.setProperty("margin", "0", "important");
      });
      el.querySelectorAll("svg, img").forEach((c) => {
        c.style.setProperty("opacity", "0.45", "important");
        c.style.setProperty("height", "12px", "important");
        c.style.setProperty("width", "auto", "important");
      });
    };

    const tryApply = () => {
      const el = document.getElementById("emergent-badge");
      apply(el);
    };

    // Run now + observe DOM in case it appears later or its style is reset
    tryApply();
    const observer = new MutationObserver(() => tryApply());
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style"],
    });

    return () => observer.disconnect();
  }, []);
};

export default useEmergentBadgeStyle;
